<template>
    <div class="practitioner-edit mb-3 mt-page">

        <data-form ref="dataForm"
                   :title="$i18n.gt('HEADING_EDIT_PRACTITIONER')"
                   :save-button-label="$i18n.gt('LABEL_SAVE')"
                   :field-model="practitionerFields"
                   :field-groups="fieldGroups"
                   :load-model-instance="loadModelInstance"
                   :on-submit-handler="onSubmit"
                   :submit-success-message="$i18n.gt('LABEL_PRACTITIONER_UPDATED')"
                   :submit-error-message="$i18n.gt('LABEL_ERROR_UPDATING_PRACTITIONER')"
                   :submit-success-route="successRoute"
                   :cancel-route="successRoute">
            <template v-slot:labelSlot="slotProps">
                <emr-lookup-practitioner-modal v-if="emrReadEnabled"
                                               :fieldModel="slotProps.fieldModel"
                                               :form="slotProps.form"
                                               :company="companyId"
                                               :practice="practiceId"/>
                <b-btn v-if="emrWriteEnabled && practitionerId && !hasEmr"
                       class="btn-secondary ml-2"
                       size="sm"
                       @click="emrCreate()">
                    {{ $i18n.gt('LABEL_EMR_CREATE') }}
                </b-btn>
            </template>
        </data-form>

    </div>
</template>

<script>

import Vue from 'vue'
import PractitionerFields from '@/models/Practitioner'

/**
 * Page to edit a Practitioner - either by an admin or by a practice manager/practitioner
 */
export default Vue.extend({
    name: 'PractitionerEdit',
    props: {
        companyId: Number,
        practiceId: Number,
        practitionerId: Number
    },
    data() {
        return {
            practitionerFields: PractitionerFields,
            fieldGroups: [
                ['email', 'firstname', 'lastname'],
                ['role', 'title', 'receive_appointment_alert', 'npi', 'practitioner_code_id', 'emr_id', 'disabled'],
            ],
            emrReadEnabled: false,
            emrWriteEnabled: false,
            hasEmr: false,
        }
    },
    computed: {
        successRoute() {
            if (this.$user.roleIsAdmin()) {
                return `/practitioner/admin/companyId/${this.companyId}/practiceId/${this.practiceId}`
            } else {
                return '/practice/practitionerAdmin'
            }
        },
    },
    mounted() {
        this.$api.emrScope(this, {
            company: this.companyId,
            practice: this.practiceId
        })
            .then((scope) => {
                if (scope) {
                    this.emrReadEnabled = scope.includes('practitioner.read')
                    this.emrWriteEnabled = scope.includes('practitioner.write')
                }
            })
    },
    methods: {
        loadModelInstance() {
            return this.$api.getItem(this, 'practitioner', this.practitionerId)
                .then((practitioner) => {
                    this.hasEmr = practitioner && !!practitioner['emr_id']
                    return practitioner
                })
        },
        onSubmit(modelInstance) {
            return this.$api.updateItem(this, 'practitioner', modelInstance)
                .then((result) => {
                    if (result && result.ok) {
                        this.$api.emrUpdate(this, 'practitioner', this.practitionerId)
                            .then((result2) => this.$utils.handleEMRError(result2))
                    }
                })
        },
        async emrCreate() {
            if (await this.$bvModal.msgBoxConfirm(this.$i18n.gt('LABEL_EMR_CONFIRM_CREATE_PRACTITIONER'))) {
                try {
                    let result = await this.$api.emrUpdate(this, 'practitioner', this.practitionerId)
                    if (result && !this.$utils.handleEMRError(result) && result.id) {
                        if (this.$refs.dataForm && this.$refs.dataForm.form) {
                            this.$refs.dataForm.form.emr_id = result.id
                        }
                    }
                } catch (e) {
                    this.$utils.handleError(e, 'Unable to create EMR record.')
                }
            }
        },
    }
})

</script>
